import * as React from "react";
import { inject } from "mobx-react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import LoadingWidget from "./LoadingWidget";
import { SessionStore } from "../../stores/SessionStore";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";

// import { CustomerStore } from "../../stores/CustomerStore";

export interface Props {
    toggleFunction: () => void;
    sessionStore?: SessionStore;
}
export interface State {
    isShown: boolean;
    isWarning: boolean;
    currentPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    wasValidated: boolean;
    message: string;
    isLoading: boolean;
}

@inject("sessionStore")
// @observer
export default class NewPasswordDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isShown: true,
            isWarning: false,
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            wasValidated: false,
            message: "",
            isLoading: false
        };
    }

    checkPasswords = (): boolean => {
        this.setState({ wasValidated: true });
        if (this.state.currentPassword === "" || this.state.newPassword === "" || this.state.confirmNewPassword === "") {
            return false;
        } else if (this.state.currentPassword === this.state.newPassword || this.state.currentPassword === this.state.confirmNewPassword) {
            //Message Same Password current and new
            this.setState({ message: "the new password is the same as the current one." });
            return false;
        } else if (this.state.newPassword !== this.state.confirmNewPassword) {
            //Message Diferent Password
            this.setState({ message: "passwords do not match." });
            return false;
        } else {
            //Message Empty
            this.setState({ message: "" });
            return true;
        }
    };

    handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
        const target = event.currentTarget;
        const value = target.value;
        const name = target.name;

        const state = this.state;
        state[name] = value;
        this.setState(state);
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();

        if (this.checkPasswords()) {
            this.setState({ isLoading: true });
            this.props
                .sessionStore!.changePassword(this.state.currentPassword, this.state.newPassword, this.state.confirmNewPassword)
                .then(() => this.setState({ isShown: false })) //TODO Message Change
                .catch(err => this.setState({ isLoading: false, message: err }));
        }
    };

    render() {
        return (
            <div>
                <Modal isOpen={this.state.isShown} className="modal-md" centered={true}>
                    <ModalHeader>New Password</ModalHeader>
                    <ModalBody>
                        {this.state.isLoading && <LoadingWidget />}

                        <div className="container-fluid">
                            <form
                                className={"mt-3 needs-validation " + (this.state.wasValidated === true ? "was-validated" : "")}
                                noValidate={true}
                                onSubmit={e => this.submit(e)}
                            >
                                {this.state.message !== "" && (
                                    <div className="alert alert-warning" role="alert">
                                        <b> Warning: </b> {this.state.message}
                                    </div>
                                )}
                                <div className="form-group">
                                    <label htmlFor="currentPassword">
                                        Current Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="inputGroupPrepend">
                                                <FontAwesomeIcon icon={faKey} />
                                            </span>
                                        </div>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="currentPassword"
                                            placeholder="Current password"
                                            aria-describedby="inputGroupPrepend"
                                            name="currentPassword"
                                            value={this.state.currentPassword}
                                            onChange={this.handleOnChange}
                                            required={true}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="newPassword">
                                        New Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="inputGroupPrepend">
                                                <FontAwesomeIcon icon={faKey} />
                                            </span>
                                        </div>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="newPassword"
                                            placeholder="New Password"
                                            aria-describedby="inputGroupPrepend"
                                            name="newPassword"
                                            value={this.state.newPassword}
                                            onChange={this.handleOnChange}
                                            required={true}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmNewPassword">
                                        Confirm New Password <span className="text-danger">*</span>
                                    </label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="inputGroupPrepend">
                                                <FontAwesomeIcon icon={faKey} />
                                            </span>
                                        </div>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confirmNewPassword"
                                            placeholder="Confirm New Number"
                                            aria-describedby="inputGroupPrepend"
                                            name="confirmNewPassword"
                                            value={this.state.confirmNewPassword}
                                            onChange={this.handleOnChange}
                                            required={true}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer px-0">
                                    <button className="btn btn-secondary" type="button" onClick={this.props.toggleFunction}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-primary ml-auto" type="submit">
                                        Change Password
                                    </button>
                                </div>
                            </form>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/NewPasswordDialog.tsx